import list from "../../common/lib/helpers/list";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

const initialState = getInitialState.list();

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.DEBUG_STATE_CLEAR: {
            return initialState;
        }
        case actionTypes.DEBUG_ST_ITEM_CLEAR: {
            return { ...state, item: null };
        }
        case actionTypes.DEBUG_ST_ITEM_SET: {
            const { auditAsset } = action.payload;
            return { ...state, item: auditAsset };
        }
        case actionTypes.DEBUG_ST_ITEM_UPDATE: {
            const { auditAsset } = action.payload;
            const { item } = state;
            return { ...state, item: { ...item, ...auditAsset } };
        }
        case actionTypes.DEBUG_STATE_DATA_UPD: {
            const { assetIds } = action.payload;
            const { data } = state;
            const updateData = [...data];

            updateData.map((obj) => {
                if (assetIds.includes(obj.id)) obj.isAssigned = true;
                return obj;
            });

            return { ...state, data: updateData };
        }
        case actionTypes.DEBUG_STATE_SELECT_SUCCESS: {
            const { auditAssets } = action.payload;
            return list.getReducer(state, auditAssets);
        }
        case actionTypes.DEBUG_STATE_WRITE_SUCCESS: {
            const { auditAssets } = action.payload;
            return list.mergeReducer(state, auditAssets);
        }
        default: {
            return state;
        }
    }
}
